import { render, staticRenderFns } from "./PrivateRoomEntrance.vue?vue&type=template&id=3765c18a"
import script from "./PrivateRoomEntrance.vue?vue&type=script&lang=js"
export * from "./PrivateRoomEntrance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3765c18a')) {
      api.createRecord('3765c18a', component.options)
    } else {
      api.reload('3765c18a', component.options)
    }
    module.hot.accept("./PrivateRoomEntrance.vue?vue&type=template&id=3765c18a", function () {
      api.rerender('3765c18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrivateRoomEntrance.vue"
export default component.exports